import { render, staticRenderFns } from "./CvtechComp.vue?vue&type=template&id=56cddba2&scoped=true"
import script from "./CvtechComp.vue?vue&type=script&lang=js"
export * from "./CvtechComp.vue?vue&type=script&lang=js"
import style0 from "./CvtechComp.vue?vue&type=style&index=0&id=56cddba2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cddba2",
  null
  
)

export default component.exports